/*
  Toggles `hb-footer-in-view` on <html> while the footer is on screen, so that
  floating third-party launchers (accessibility widget, cookie-settings button)
  can step out of the way instead of sitting on top of the footer.

  Presentational only: it adds and removes one class and touches nothing else.
  See assets/ui-overlay-system.css for what the class does.
*/
(function () {
  "use strict";

  var CLASS_NAME = "hb-footer-in-view";
  var root = document.documentElement;

  function init() {
    var footer =
      document.querySelector(".shopify-section-group-footer-group") ||
      document.querySelector("#shopify-section-footer") ||
      document.querySelector('[id*="shopify-section"][id*="footer"]') ||
      document.querySelector("footer.footer") ||
      document.querySelector("footer");

    if (!footer) return;

    // Without IntersectionObserver the launchers simply keep their default
    // behaviour — no fallback scroll handler, no jank.
    if (typeof window.IntersectionObserver !== "function") return;

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          root.classList.toggle(CLASS_NAME, entries[i].isIntersecting);
        }
      },
      {
        // Start the handoff slightly before the footer's top edge arrives so the
        // launcher is already gone by the time the footer is properly in view.
        rootMargin: "0px 0px -40px 0px",
        threshold: 0,
      }
    );

    observer.observe(footer);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
